import React from 'react';
import PropTypes from 'prop-types';

export const Logo = ({ logo, logoAltText }) => (
  <img
    src={logo}
    alt={logoAltText}
    className="site-header__logo"
  />
)

const NavLogo = function MobileNavComponent({ siteGlobals, logo }) {
  const logoAltText = siteGlobals.navLogoAltText ?? `${siteGlobals.siteName} logo`;

  return (
    <div className="site-header__branding">
      {siteGlobals.disableLogo ? <Logo logo={logo} logoAltText={logoAltText} /> :
        <a href={siteGlobals.homeURL} title={`${siteGlobals.siteName} Homepage`} className="site-header__logo-wrap">
          <Logo logo={logo} logoAltText={logoAltText} />
        </a>}
    </div>
  );
};

NavLogo.propTypes = {
  logo: PropTypes.string.isRequired,
  siteGlobals: PropTypes.shape({}).isRequired,
};

export default NavLogo;
